import { router } from "@inertiajs/react";
import ActivityType from "types/ActivityType";
import Icon from "hardcover-ui/components/Icon";
import faTrash from "icons/solid/trash.svg";
import { useMutation } from "lib/apollo/client";
import deleteActivityForUserMutation from "queries/feed/deleteActivityForUserMutation";
import useMount from "hooks/useMount";
import { MenuItem } from "@headlessui/react";
import Button from "hardcover-ui/components/Button";
import useCurrentUserId from "hooks/user/useCurrentUserId";

export interface Props {
  activity: ActivityType;
  onDelete: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function DeleteMenuButton({ activity, onDelete }: Props) {
  const currentUserId = useCurrentUserId();
  const isDeleteActivityButtonVisible = currentUserId === activity.userId;
  const mounted = useMount();

  const [deleteActivity] = useMutation(deleteActivityForUserMutation);

  const onDeleteActivity = () => {
    deleteActivity({
      variables: { activityId: activity.id },
    }).then(() => {
      if (onDelete) {
        onDelete();
      } else {
        router.visit(`/@${activity.user.username}/activity`);
      }
    });
  };

  if (!mounted || !isDeleteActivityButtonVisible) {
    return false;
  }

  return (
    <MenuItem>
      <Button
        size="md"
        data-name="Delete Activity"
        className="w-full  group text-foreground hover:bg-primary hover:text-primary-foreground  font-semibold justify-between"
        onClick={onDeleteActivity}
      >
        <span>Delete Activity</span>
        <Icon icon={faTrash} size="lg" />
      </Button>
    </MenuItem>
  );
}
